/**
 * What `permission` is called on screen.
 *
 * Every profile serializer returns this field, so it is the one label that
 * works for the five account types without branching. A user with no profile
 * at all gets `undefined` and the card simply shows no role, which is honest:
 * there is none.
 */
export const ROLE_LABELS = {
  admin: 'Administrador',
  seller: 'Vendedor',
  operator: 'Operador',
  driver: 'Conductor',
};

/** `UserOperativeMailsSerializer` declares `ListField(max_length=5)`. */
export const MAX_OPERATIVE_MAILS = 5;

/** Both the code and the token it buys expire after this long. */
export const SECURE_CODE_TTL_MINUTES = 5;

export const SECURE_CODE_LENGTH = 6;

/**
 * Good enough to catch a typo before spending a round trip; the backend's
 * `EmailField` is still the authority. Deliberately not a full RFC 5322
 * matcher — those reject addresses that work and accept ones that do not.
 */
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (value) => EMAIL_PATTERN.test(String(value || '').trim());
